import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Users, DollarSign, TrendingUp } from 'lucide-react';

const LandingPage = () => {
  const navigate = useNavigate();

  const goToMarketplace = () => {
    navigate('/marketplace');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-32">
      <div className="container mx-auto px-4 py-20">
        <h1 className="text-6xl font-bold mb-8 text-center">
          Trade on the Most Liquid Primary Market
        </h1>
        <p className="text-2xl text-center mb-16">
          Get first access to the most important tokens in the crypto space.
        </p>
        <div className="flex justify-center mb-20">
          <button
            className="px-8 py-4 text-xl font-semibold bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:opacity-90 transition-opacity duration-200 flex items-center"
            onClick={goToMarketplace}
          >
            Explore Marketplace <ArrowRight className="ml-2" size={24} />
          </button>
        </div>
        <div className="grid md:grid-cols-3 gap-12 text-center">
          <div className="bg-gray-800 p-8 rounded-lg">
            <TrendingUp size={64} className="mx-auto mb-6 text-purple-500" />
            <h2 className="text-4xl font-bold mb-3">15x</h2>
            <p className="text-xl text-gray-400">Average ROI</p>
          </div>
          <div className="bg-gray-800 p-8 rounded-lg">
            <Users size={64} className="mx-auto mb-6 text-purple-500" />
            <h2 className="text-4xl font-bold mb-3">200,100</h2>
            <p className="text-xl text-gray-400">Active Participants</p>
          </div>
          <div className="bg-gray-800 p-8 rounded-lg">
            <DollarSign size={64} className="mx-auto mb-6 text-purple-500" />
            <h2 className="text-4xl font-bold mb-3">$1 billion+</h2>
            <p className="text-xl text-gray-400">Total Assets Connected</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;